import React, { forwardRef } from 'react';
import { cn } from '../../lib/utils';
export interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string;
  error?: string;
}
const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(({
  className,
  label,
  error,
  ...props
}, ref) => {
  return <div className="w-full" data-id="element-2864">
        {label && <label className="mb-2 block text-sm font-medium text-foreground" data-id="element-2865">
            {label}
          </label>}
        <textarea className={cn('flex min-h-[80px] w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50', error && 'border-destructive focus-visible:ring-destructive', className)} ref={ref} {...props} data-id="element-2866" />
        {error && <p className="mt-1 text-sm text-destructive" data-id="element-2867">{error}</p>}
      </div>;
});
Textarea.displayName = 'Textarea';
export { Textarea };